import { Loader } from '.';

export default function PageLoader() {
  return (
    <div className="flex h-screen w-full flex-row content-center justify-center">
      <Loader size="xl" />
    </div>
  );
}
